module.exports = __webpack_public_path__ + "static/wx.8ec9f86e.png";